/*
 *
 * AmlPopup
 *
 * @version 1.0.0
 * @author Minozzi Elia
 * @since 30-Giu-2025
*/

import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import formattedMessage from './languageModule'
import Toggle from 'Hoc/ToggleComponent'
import MerchantModal from '@nexidigital/merchantmodal'
import { AML_STATUSES } from 'Route/Aml/modules/AmlConstants'
import PortalInfoBox from '@nexidigital/portalinfobox'
import './AmlPopup.scss'
import { ArrowExit } from '@nexidigital/iconlibrary'
import PortalLoader from '@nexidigital/portalloader'
import { useNavigate } from 'react-router-dom'
import { flowPopupMapType } from 'Utility/flowPopupMap'
import { useIntl } from 'react-intl'
import { roles } from 'Utility/utils'

const AmlPopup = (props) => {
  const [statusConfig, setConfig] = useState({
    title: formattedMessage.amlTitle,
    subtitle: null,
    description: formattedMessage.amlPopUpDescription,
    cta: formattedMessage.view,
    onCta: () => { }, // goToOtp
    cta2: null,
    onCta2: null
  })
  const navigate = useNavigate()
  const intl = useIntl()

  const handleOtpClose = () => {
    if (props.fromTTL && ![AML_STATUSES.BLOCKED, AML_STATUSES.ADMIN_BLOCKED].includes(props.amlStatus)) {
      props.actions.doHidePopup()
      props.actions.doRetrieveTTL()
    } else {
      props.actions.doShowPopup(flowPopupMapType.AML_MODAL)
    }
  }

  const handleCheckOtpAml = () => {
    if (props.fromTTL) {
      props.actions.doHideTtl()
    }

    props.actions.doCheckOtpAml({
      status: props.amlStatus,
      title: intl.formatMessage({
        id: 't.app.aml.otpPopUp.title'
      }),
      onClose: handleOtpClose
    })
  }

  const setAmlConfig = () => {
    let popupStatus = props.amlStatus
    const canManageAml = [roles.ADMIN, roles.SECONDARY_OFFICER].includes(props.userRole)
    if ([AML_STATUSES.NON_COMPLIANT, AML_STATUSES.ADMIN_NON_COMPLIANT].includes(popupStatus)) {
      popupStatus = canManageAml ? AML_STATUSES.NON_COMPLIANT : AML_STATUSES.ADMIN_NON_COMPLIANT
      if (canManageAml && props.amlUpdating) popupStatus = AML_STATUSES.PERSONAL_DATA_UNDEFINED
    } else if ([AML_STATUSES.BLOCKED, AML_STATUSES.ADMIN_BLOCKED].includes(popupStatus)) {
      popupStatus = canManageAml || props.amlUpdating ? AML_STATUSES.BLOCKED : AML_STATUSES.ADMIN_BLOCKED
    }

    switch (popupStatus) {
      case (AML_STATUSES.NON_COMPLIANT): // UCIB-1581 NB: if not survayUpdating !!!
        if (!props.amlUpdating) {
          setConfig({
            title: formattedMessage.amlTitle,
            subtitle: null,
            description: formattedMessage.amlPopUpDescription,
            cta: formattedMessage.view,
            onCta: handleCheckOtpAml,
            handleClose: () => {
              if (props.fromTTL) {
                props.actions.doHideTtl()
                props.actions.doRetrieveTTL()
              } else {
                props.actions.doHidePopup()
              }
            }
          })
        }
        break
      case (AML_STATUSES.BLOCKED):
        if (!props.amlUpdating) {
          // UCIB-1582
          setConfig({
            title: formattedMessage.amlTitleBlocked,
            subtitle: formattedMessage.amlPopUpDescriptionNotCompliantBlocked,
            description: formattedMessage.amlPopUpDescription,
            cta: formattedMessage.view,
            onCta: handleCheckOtpAml,
            cta2: formattedMessage.exit,
            onCta2: () => props.actions.doLogout(),
            icon2: <ArrowExit size='20' type='line' />,
            handleClose: null
          })
        } else {
          // UCIB-1588
          setConfig({
            title: formattedMessage.amlTitlePersonalDataUndefined,
            subtitle: formattedMessage.amlPopUpDescriptionBlockedUpdating,
            description: formattedMessage.amlPopUpDescription,
            cta: formattedMessage.exit,
            icon1: <ArrowExit size='20' type='line' />,
            onCta: () => props.actions.doLogout(),
            handleClose: null
          })
        }
        break
      case AML_STATUSES.PERSONAL_DATA_UNDEFINED: // UCIB-1584
        setConfig({
          title: formattedMessage.amlTitlePersonalDataUndefined,
          subtitle: formattedMessage.amlPopUpDescriptionPersonalDataUndefined,
          description: formattedMessage.amlPopUpDescription,
          cta: formattedMessage.okUnderstood,
          onCta: () => {
            if (props.fromTTL) {
              props.actions.doHideTtl()
              props.actions.doRetrieveTTL()
            } else {
              props.actions.doHidePopup()
            }
          },
          handleClose: () => {
            if (props.fromTTL) {
              props.actions.doHideTtl()
              props.actions.doRetrieveTTL()
            } else {
              props.actions.doHidePopup()
            }
          }
        })
        break
      case AML_STATUSES.RELATED_DATA_NON_PRESENT: // UCIB-1585
        setConfig({
          title: formattedMessage.amlTitleDataNonPresent,
          subtitle: formattedMessage.amlPopUpDescriptionDataNonPresent,
          description: formattedMessage.amlPopUpDescription,
          cta: formattedMessage.okUnderstood,
          onCta: () => {
            if (props.fromTTL) {
              props.actions.doHideTtl()
              props.actions.doRetrieveTTL()
            } else {
              props.actions.doHidePopup()
            }
          },
          handleClose: () => {
            if (props.fromTTL) {
              props.actions.doHideTtl()
              props.actions.doRetrieveTTL()
            } else {
              props.actions.doHidePopup()
            }
          }
        })
        break
      case AML_STATUSES.COMPLIANT: // UCIB-1586
        setConfig({
          title: formattedMessage.amlTitle,
          subtitle: null,
          description: formattedMessage.amlPopUpDescription,
          cta: formattedMessage.goToSurvey,
          onCta: () => {
            if (props.fromTTL) {
              props.actions.doHideTtl()
              props.actions.doRetrieveTTL()
            } else {
              props.actions.doHidePopup()
            }
            navigate('/aml')
          },
          handleClose: () => {
            if (props.fromTTL) {
              props.actions.doHideTtl()
              props.actions.doRetrieveTTL()
            } else {
              props.actions.doHidePopup()
            }
          }
        })
        break
      case AML_STATUSES.ADMIN_NON_COMPLIANT: // UCIB-1591
        setConfig({
          title: formattedMessage.amlTitle,
          subtitle: formattedMessage.amlPopUpDescriptionAdminNonCompliant,
          description: formattedMessage.amlPopUpDescription,
          cta: formattedMessage.okUnderstood,
          onCta: () => {
            if (props.fromTTL) {
              props.actions.doHideTtl()
              props.actions.doRetrieveTTL()
            } else {
              props.actions.doHidePopup()
            }
          },
          handleClose: () => {
            if (props.fromTTL) {
              props.actions.doHideTtl()
              props.actions.doRetrieveTTL()
            } else {
              props.actions.doHidePopup()
            }
          }
        })
        break
      case AML_STATUSES.ADMIN_BLOCKED: // UCIB-1592
        setConfig({
          title: formattedMessage.amlTitleBlocked,
          subtitle: formattedMessage.amlPopUpDescriptionAdminBlocked,
          description: formattedMessage.amlPopUpDescription,
          cta: formattedMessage.exit,
          onCta: () => props.actions.doLogout(),
          icon1: <ArrowExit size='20' type='line' />,
          handleClose: null
        })
        break
      default:
        setConfig({
          title: formattedMessage.amlTitle,
          subtitle: null,
          description: formattedMessage.amlPopUpDescription,
          cta: formattedMessage.view,
          onCta: handleCheckOtpAml,
          handleClose: () => {
            if (props.fromTTL) {
              props.actions.doHideTtl()
              props.actions.doRetrieveTTL()
            } else {
              props.actions.doHidePopup()
            }
          }
        })
        break
    }
  }

  useEffect(() => {
    setAmlConfig()
  }, [props.amlStatus, props.amlUpdating, props.userRole, props.fromTTL])

  return (
    <Toggle>
      {props.isLoading
        ? (
          <PortalLoader circular />
          )
        : (
          <MerchantModal
            title={statusConfig.title}
            description={<div className='amlModalDescription'>{statusConfig.subtitle}</div>}
            primaryButtonLabel={statusConfig.cta}
            primaryAction={() => statusConfig.onCta()}
            primaryButtonLoading={props.isLoading}
            primaryIcon={statusConfig.icon1}
            secondaryButtonLabel={statusConfig.cta2}
            secondaryIcon={statusConfig.icon2}
            secondaryAction={() => statusConfig.onCta2()}
            onClose={statusConfig.handleClose}
          >
            <PortalInfoBox primary>
              {statusConfig.description}
            </PortalInfoBox>
          </MerchantModal>
          )}
    </Toggle>
  )
}

AmlPopup.propTypes = {
  actions: PropTypes.object,
  newsInfo: PropTypes.object,
  isLoading: PropTypes.bool,
  isTTLread: PropTypes.bool,
  fromTTL: PropTypes.bool,
  amlStatus: PropTypes.string,
  amlUpdating: PropTypes.bool,
  userRole: PropTypes.string
}

AmlPopup.defaultProps = {
  actions: {},
  fromTTL: false,
  isLoading: false,
  isTTLread: false,
  amlStatus: 'COMPLIANT',
  amlUpdating: false,
  userRole: ''
}

export default AmlPopup
